import { render, staticRenderFns } from "./uploadCertificate.vue?vue&type=template&id=0b8df2dc&scoped=true"
import script from "./uploadCertificate.vue?vue&type=script&lang=js"
export * from "./uploadCertificate.vue?vue&type=script&lang=js"
import style0 from "./uploadCertificate.vue?vue&type=style&index=0&id=0b8df2dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8df2dc",
  null
  
)

export default component.exports